import Component from "./StandardListWithSearch";
export default Component;
